import moment from 'moment'
import { checkIsValidCNPJ, checkIsValidCPF } from './cpfAndCnpjValidation'

const checkHour = v => /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || 'Horário inválido'

const validDate = (value) => {
  const invalidMsg = 'Data inválida'
  if (!value) return invalidMsg

  const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/ // Formato DD/MM/YYYY
  if (!dateRegex.test(value)) return invalidMsg

  const [day, month, year] = value.split('/').map(Number)
  const date = new Date(year, month - 1, day)

  const isValidDate =
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day

  if (!isValidDate) return invalidMsg

  return true
}

const validBirthdate = (value) => {
  const invalidMsg = 'Data inválida'
  if (validDate(value) !== true) return invalidMsg

  const [day, month, year] = value.split('/').map(Number)
  
  const today = new Date()
  const age =
    today.getFullYear() - year -
    (today.getMonth() < month - 1 ||
    (today.getMonth() === month - 1 && today.getDate() < day)
      ? 1
      : 0)
  
  if (age < 18 || age > 130) return invalidMsg

  return true  
}

const minCaracters = (text, minValue) => text && text.length >= minValue || `Digite ao menos ${minValue} caracteres`

const maxCaracters = (text, maxValue) => text && text.length <= maxValue || `Digite no máximo ${maxValue} caracteres`

const minCaractersCustomMsg = (text, minValue, message) => text && text.length >= minValue || message

const minValue = (text, minValue) => Number(text) >= minValue || `O valor mínimo é ${minValue}`

const minValueAlt = (text, minValue, msg) => Number(text) >= minValue || msg

const maxValue = (text, maxValue) => Number(text) <= maxValue || `O valor máximo é ${maxValue}`

const maxValueAlt = (text, maxValue, msg) => Number(text) <= maxValue || msg

const itsRequired = v => !!v || 'Campo obrigatório'

const onlyLettersAndNumbers = v => /^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*$/.test(v) || 'Apenas letras ou números'

const checkEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail inválido'

const checkPhone = v => v && v.length >= 16 || 'Número telefone/celular inválido'

const checkMaskedPhone = v => /^(\(?\d{2}\)?\s?)?(\d{4,5}-?\d{4})$/.test(v) || 'Número de telefone/celular inválido'

const checkUrl = v => /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/.test(v) || 'Url inválida'

const preventPastTime = (time, date) => {
  const checkDate = moment(date)
  const sendDate = `${date} ${time}`
  let sendDateCheck = false

  if (time && time.length === 5 && checkDate) sendDateCheck = moment(sendDate, 'YYYY-MM-DD HH:mm:ss').isAfter()

  return sendDateCheck || 'Data/Horário ultrapassado(s)'
}

const preventPastDate = (date) => {
  const checkDate = moment(date)
  const sendDate = `${date}`
  let sendDateCheck = false

  if (checkDate) sendDateCheck = moment(sendDate, 'YYYY-MM-DD').isAfter()

  return sendDateCheck || 'Data ultrapassada'
}

const preventFinishEventDate = (time, date, maxEventDate, maxEventHour) => {
  const sendDate = `${date} ${time}`
  let eventOver = false

  if (maxEventDate && maxEventHour) {
    const finishDate = `${maxEventDate} ${maxEventHour}`
    eventOver = moment(sendDate, 'YYYY-MM-DD HH:mm:ss').isAfter(moment(finishDate))
  }

  return !eventOver || 'Horário não permitido'
}

const noData = (array, msg) => {
  return array.length > 0 || msg
}

const preventInitialPeriodGreaterThanEndPeriod = (initialMonth, initialYear, endMonth, endYear) => {
  return !moment(`${initialMonth}/${initialYear}`, 'MM/YYYY').isAfter(moment(`${endMonth}/${endYear}`, 'MM/YYYY')) || 'Mês/Ano Inicial não pode ser maior que o final'
}

const isValidCpfNotRequired = v => !v ? true : checkIsValidCPF(v) || 'CPF inválido'

const isValidCpf = v => checkIsValidCPF(v) || 'CPF inválido'

const isValidCnpj = v => checkIsValidCNPJ(v) || 'CNPJ inválido'

const preventRepeatedItems = (array, message = 'Itens não podem ser iguais') => {
  const stringifyItens = array.map(item => JSON.stringify(item))
  return new Set(stringifyItens).size === array.length || message
}

// NOT REQUIRED

/*
  anotherFields: [{label: "Nome", value: 'valorDigitado'}]
 */
const onlyRequiredIfAnotherFieldIsNotEmpty = (value, anotherFields) => {
  if (!value) return true
  else {
    const emptyFieldsLabel = []
    const emptyFields = anotherFields.some((v, index) => {
      if (!v.value) emptyFieldsLabel.push(v.label)
      if (index === anotherFields.length - 1 && emptyFieldsLabel.length > 0) return true
    })
    if (emptyFields) return `Você também deve preencher: ${emptyFieldsLabel.toString()}`
    else return true
  }
}

const checkHourNotRequired = v => !v ? true : checkHour(v)

const validDateNotRequired = v => !v ? true : validDate(v)

const preventPastDateNotRequired = (date) => !date ? true : preventPastDate(date)

const preventPastTimeNotRequired = (time, date) => !time && !date ? true : preventPastTime(time, date)

const preventFinishEventDateNotRequired = (time, date, maxEventDate, maxEventHour) => !time && !date && !maxEventDate && !maxEventHour ? true : preventFinishEventDate(time, date, maxEventDate, maxEventHour)

const minCaractersNotRequired = (text, minValue) => !text ? true : minCaracters(text, minValue)

const checkEmailNotRequired = v => !v ? true : checkEmail(v)

const checkEmailExceptionNotRequired = (v, exception) => v === exception ? true : checkEmailNotRequired(v)

const checkPhoneNotRequired = v => !v ? true : checkPhone(v)

const checkMaskedPhoneNotRequired = v => !v ? true : checkMaskedPhone(v)

const preventRepeatedItemsNotRequired = (array, message) => !array ? true : preventRepeatedItems(array, message)

export default {
  checkHour,
  validDate,
  validBirthdate,
  minCaracters,
  maxCaracters,
  minCaractersCustomMsg,
  minValue,
  minValueAlt,
  maxValue,
  maxValueAlt,
  checkUrl,
  checkEmail,
  checkEmailExceptionNotRequired,
  itsRequired,
  onlyLettersAndNumbers,
  preventPastTime,
  preventPastDate,
  preventFinishEventDate,
  preventInitialPeriodGreaterThanEndPeriod,
  noData,
  isValidCnpj,
  isValidCpf,
  checkPhone,
  checkHourNotRequired,
  validDateNotRequired,
  preventPastDateNotRequired,
  preventPastTimeNotRequired,
  preventFinishEventDateNotRequired,
  minCaractersNotRequired,
  checkEmailNotRequired,
  checkPhoneNotRequired,
  onlyRequiredIfAnotherFieldIsNotEmpty,
  preventRepeatedItemsNotRequired,
  preventRepeatedItems,
  checkMaskedPhone,
  checkMaskedPhoneNotRequired,
  isValidCpfNotRequired
}
